/** angular */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
/** end angular */

@Pipe({
  name: 'bydSanitize',
})
export class BydSanitizePipe implements PipeTransform {
  /**
   * Creates an instance of BydSanitizePipe.
   *
   * @param sanitizer The DOM sanitizer
   */
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Returns sanitized HTML string.
   *
   * @param htmlString The string containing HTML content
   * @returns Safe HTML
   */
  public transform(htmlString: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlString);
  }
}
